import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface DeleteCbcDataByMeResponse {
  callSuccess: string;
  errorMessage?: string;
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class CbcDeleteDataByMeService {
  constructor(private http: HttpClient) {}

  private mergeParams(
    globalService: any,
    filterParams: any,
    explicitParams: Record<string, string | number | null | undefined>
  ): HttpParams {
    const merged: Record<string, string> = {};
    const g = globalService || {};
    const f = filterParams || {};
    Object.keys(g).forEach((k) => {
      if (g[k] != null && g[k] !== '') merged[k] = String(g[k]);
    });
    Object.keys(f).forEach((k) => {
      if (f[k] != null && f[k] !== '') merged[k] = String(f[k]);
    });
    Object.keys(explicitParams).forEach((k) => {
      const v = explicitParams[k];
      if (v != null && v !== '') merged[k] = String(v);
    });
    let p = new HttpParams();
    Object.keys(merged).forEach((k) => { p = p.set(k, merged[k]); });
    return p;
  }

  deleteCbcDataByMe(
    baseUrl: string,
    ssoId: string,
    meCode: string,
    ttKey: string,
    globalService: any = {},
    filterParams: any = {}
  ): Observable<DeleteCbcDataByMeResponse> {
    const url = `${baseUrl}/saveJsonObject?action_code=4hedey`;
    const params = this.mergeParams(globalService, filterParams, {
      sso_id: ssoId,
      tax_year: filterParams?.tax_year,
      scenario: filterParams?.scenario,
      me_code: meCode,
      tt_key: ttKey,
    });
    const body = params.toString();
    return this.http.post<DeleteCbcDataByMeResponse>(url, body, {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true,
    });
  }
}
